<template>
  <div>
    <div
      v-if="withHeader"
      class="w-100 d-flex justify-content-between align-items-center "
    >
      <h6 class="my-0">
        {{ $t("components.blocks.tagFilterListBlock.filterBy") }}
      </h6>
    </div>
    <div class="mt-2 ml-n2 pl-2 tags d-flex">
      <v-button
        class="tags__button"
        small
        :secondary="hasFilterTags"
        @click="handleClearTags"
      >
        {{ $t("components.blocks.tagFilterListBlock.all") }}
      </v-button>
      <v-button
        class="tags__button"
        v-for="(tag, i) in allTags"
        :key="`${i}-${tag}`"
        small
        :secondary="!isTagActive(tag)"
        @click="() => handleClickTag(tag)"
      >
        {{ tag }}
      </v-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tags: { type: Array, default: () => [] },
    withHeader: { type: Boolean, default: true }
  },

  data() {
    return {
      isLoading: false,
      filterTags: []
    }
  },

  computed: {
    allTags() {
      return this.tags.map(t => t.text)
    },

    hasFilterTags() {
      return this.filterTags.length > 0
    }
  },

  methods: {
    isTagActive(tag) {
      return this.filterTags.some(item => item === tag)
    },

    handleClearTags() {
      this.filterTags = []
      this.$emit("updated", this.filterTags)
    },

    handleClickTag(tag) {
      if (this.isTagActive(tag)) {
        this.filterTags = this.filterTags.filter(item => item !== tag)
      } else {
        this.filterTags.push(tag)
      }

      this.$emit("updated", this.filterTags)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.tags {
  @include hide-scroll-bars;

  margin: initial;
  width: calc(100% + #{$size--8}); // Counters ml-n2
  overflow-x: auto;

  .v-button.tags__button {
    padding: $size--3 $size--5;
    margin-right: 0.5rem;
    overflow: unset;
  }
}
</style>
